import {$, w} from './constants';

 // --> Menú

 $('.header__hamburguer').click(function (){
    $(this).toggleClass('close');
    $('.header__menu').toggleClass('active');
    $('.hide-in-scroll').removeClass('inactive');
    $('.button-scroll').removeClass('show');
    if($('.header').attr('data-state') === "open"){
        $('.header').data('state', 'close');
        $('.header').attr('data-state', 'close');
        $('.logo-dropdown').removeClass('is-red');
        $('.logo-blog-menu').removeClass('is-black');
    }else{
        $('.header').data('state', 'open');
        $('.header').attr('data-state', 'open');
        $('.logo-dropdown').addClass('is-red');
        $('.logo-blog-menu').addClass('is-black');
    }
})

$('.has-dropdown').click(function(){
    $(this).toggleClass('open');
    $(this).siblings('.sub-menu').toggleClass('open');
})

$('.btn-newsletter').click(function(){
    $('#newsletter-pop').fadeIn(500).addClass('show');
    $('.newsletter-pop__form-container').addClass('show-demo');
})

$('.newsletter-pop__close').click(function(){
    $('#newsletter-pop').fadeOut(500).removeClass('show');
    $('.newsletter-pop__form-container').removeClass('show-demo');
})

$('#newsletter-pop').click(function(e){
    e.preventDefault();
    e.stopPropagation();
    $('#newsletter-pop').fadeOut(500).removeClass('show');
    $('.newsletter-pop__form-container').removeClass('show-demo');
})

$('.newsletter-pop__form-container').click(function(e){
    e.stopPropagation();
})

 //Scroll en links de misma página
 $('a[href*="#"]')
 .not('[href="#"]')
 .not('[href="#0"]')
 .click(function(event) {
     if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
         let target = $(this.hash);
         target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
     
         if (target.length) {
             event.preventDefault();
             $('html, body').animate({
                 scrollTop: target.offset().top - 60
             }, 1000);
         }
     }
 });

if($(window).width() > 1025){
    $('.dropdown-grid').hover(function() {
        $(this).addClass('active');
        $('.header').addClass('is-white');
        $('.logo-dropdown').addClass('is-red');
        $('.logo-blog-menu').addClass('is-black');
        $('.header').data('state', 'open');
        $('.header').attr('data-state', 'open');
    },function(){
        $(this).removeClass('active');
        $('.header').removeClass('is-white');
        $('.logo-dropdown').removeClass('is-red');
        $('.logo-blog-menu').removeClass('is-black');
        $('.header').data('state', 'close');
        $('.header').attr('data-state', 'close');
    });

    $(window).scroll(function (event) {
        const nav = $('.header');

        if($(this).scrollTop() > nav.height()){
            $('.header').addClass('is-white change');
            $('.logo-dropdown').addClass('is-red');
            $('.logo-blog-menu').addClass('is-black');
        }else{
            $('.header').removeClass('is-white change');
            $('.logo-dropdown').removeClass('is-red');
            $('.logo-blog-menu').removeClass('is-black');
        }
    });
}else{
        $('.menu-item-has-children').click(function(e){
            e.stopPropagation();
            $(this).siblings('.menu-item-has-dropdown').removeClass('active');
            $(this).toggleClass('active')
            $(this).siblings().find('.sub-menu').removeClass('active');
            $(this).children('.sub-menu').toggleClass('active');
            $('.menu-has-submenu').children('.sub-menu').removeClass('active');
        });

        $('.dropdown-grid').click(function(e) {
            e.stopPropagation();
            $(this).siblings('.dropdown-grid').removeClass('active');
            $(this).toggleClass('active');
        });

        $('.menu-item-has-dropdown').click(function(e){
            e.stopPropagation();
            $(this).siblings('.menu-item-has-children').removeClass('active');
            $(this).toggleClass('active')
            $(this).siblings().find('.sub-menu').removeClass('active');
            $(this).children('.sub-menu').toggleClass('active');
            $('.menu-has-submenu').children('.sub-menu').removeClass('active');
        });

        $(window).scroll(function (event) {
            const nav = $('.header');
            const logo = $(".hide-in-scroll");
            const cta = $(".button-scroll");
    
            if($(this).scrollTop() > nav.height()){
                nav.addClass('is-white change');
                if($('.header').attr('data-state') != "open"){
                    logo.addClass('inactive');
                    cta.addClass('show');
                }
            }else{
                nav.removeClass('is-white change');
                logo.removeClass('inactive');
                cta.removeClass('show');
            }
        });

        //Newsletter

		$('.cta_newsletter').click(function(){
			$('.single-blog__newsletter-container').fadeIn(300).addClass('show');
		})

		$('.cta_newsletter-close').click(function(){
			$('.single-blog__newsletter-container').fadeOut(300).removeClass('show');
		})
}